import { PutResponse } from '@customTypes/api/Notification';
import { Endpoints, KrakendServiceAPI } from '@service/index';
import { useMutation } from 'react-query';

const usePutNotificationRead = () => {
  return useMutation((notificationId: string) => {
    return KrakendServiceAPI.put<null, PutResponse>(
      Endpoints.NotificationRead(notificationId),
    );
  });
};

export default usePutNotificationRead;
